import styled from 'styled-components';

export const PointExpireRunContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 1rem;
  }
  .table_wrap {
    overflow-x: auto;
  }
  .nowrap {
    white-space: nowrap;
  }
  .sub_text {
    font-size: 12px;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .expire_value {
    color: #c62828;
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .danger_value {
    color: #c62828;
  }
  .warn_value {
    color: #b26a00;
  }
  .status_badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    white-space: nowrap;
    background: ${({ theme }) => theme.COLORS.GRAY_1};
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .status_success {
    background: #e3f4e3;
    color: ${({ theme }) => theme.COLORS.GREEN_1};
  }
  .status_fail {
    background: #fde4e4;
    color: #c62828;
  }
  .status_running,
  .status_partial {
    background: #fff3dc;
    color: #b26a00;
  }
  .error_text,
  .remark_text {
    margin-top: 4px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
  }
  .error_text {
    color: #c62828;
  }
  .remark_text {
    margin-top: 0;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .action_cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 6px;
  }
  .link_btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.COLORS.BLUE_4};
    color: ${({ theme }) => theme.COLORS.BLUE_4};
    font-size: 12px;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      background: ${({ theme }) => theme.COLORS.BLUE_5};
    }
    &.link_export {
      border-color: ${({ theme }) => theme.COLORS.ORANGE_1};
      color: #b26a00;
      &:hover {
        background: #fff8ec;
      }
    }
  }
`;
